/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import {Col, Row} from "react-bootstrap";


import FinishedTransportComponent from "@UIPages/Authenticated/Settings/User/MyFinishedTransports/TransportsList/Transport";


import TRANSPORT_INTERFACE from "@Services/Application/Interfaces/Transports/Transport";


type MyFinishedTransportsProps = {
    TRANSPORTS_LIST: TRANSPORT_INTERFACE[] | null;
};

export const MyFinishedTransportsListComponent: React.FC<MyFinishedTransportsProps> = ({
    TRANSPORTS_LIST
}): JSX.Element | null => {


    if (!TRANSPORTS_LIST) return null;


    const TransportsList = TRANSPORTS_LIST.map((TRANSPORT, i: number) =>
        <FinishedTransportComponent key={i} TRANSPORT={TRANSPORT} />
    );


    return (
        <Col xs={12} className={"finished-transports-list-component finished-transports-list"}>
            <Row className={"finished-transports-list-content"}>

                {TRANSPORTS_LIST.length < 1 ?

                <Col xs={12} className={"no-list-elements-message default-system-message no-transports-message"}>
                    <span>{`Brak wyników`}</span>
                </Col>

                :

                TransportsList

                }

            </Row>
        </Col>
    );


};


export default MyFinishedTransportsListComponent;
